import { rankingData } from '@/mocks/homeData';

const tagColors: Record<string, string> = {
  '爆': 'bg-primary-500/20 text-primary-400',
  '新': 'bg-accent-500/20 text-accent-400',
  '热': 'bg-primary-500/15 text-primary-300',
  '荐': 'bg-secondary-500/20 text-secondary-400',
  '疑': 'bg-secondary-500/15 text-secondary-300',
  '追': 'bg-accent-500/15 text-accent-300',
  '投': 'bg-accent-500/12 text-accent-200',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-2">热度榜单</h2>
            <p className="text-sm text-foreground-500">实时更新 · 全网最热吃瓜内容排行</p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1.5 text-xs text-foreground-500">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>
        <div className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden">
          {rankingData.map((item, i) => (
            <a key={i} href="#cards" className={`flex items-center gap-4 px-5 py-3.5 hover:bg-background-200/40 transition-colors cursor-pointer ${i < rankingData.length - 1 ? 'border-b border-background-200/40' : ''}`}>
              <span className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${i < 3 ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'}`}>
                {item.rank}
              </span>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground-200 truncate">{item.title}</p>
              </div>
              <span className={`px-2 py-0.5 text-[10px] font-medium rounded whitespace-nowrap ${tagColors[item.tag] || 'bg-background-200 text-foreground-500'}`}>{item.tag}</span>
              <span className="text-xs text-foreground-500 whitespace-nowrap hidden sm:inline">{item.heat}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}